import React, { useState, useEffect } from 'react'
import CraneSideBar from '../../../Component/Customers/slidebar/CraneSideBar.jsx'
import search from '../../../Assets/home2/search.svg'
import icon18 from '../../../Assets/crane/icon18.svg'
import icon6 from '../../../Assets/crane/icon6.svg'
import icon7 from '../../../Assets/crane/icon7.svg'
import rightarrow from '../../../Assets/navbar/right-arrow.svg'
import img2 from '../../../Assets/add/img2.png'
import icon11 from '../../../Assets/crane/icon11.svg'
import img3 from '../../../Assets/add/img3.png'
import MapForVendorDistance from '../Map/MapForVendorDistance.jsx'
import '../FirstPageDesigns/FirstPage.css';
import searchinterfacesymbol from '../../../Assets/search-interface-symbol.png'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import assignedTask from '../../../Assets/assignedTask.png'
import comingCrane from '../../../Assets/comingCrane.png'
import checksuccess from '../../../Assets/checksuccess.png'
import crossUser from '../../../Assets/crossUser.png'
import NoDataFound from '../../../Component/Customers/Cards/NoDataFound.jsx';
import filterUser from '../../../Assets/filterUser.png'
import telephonecall from '../../../Assets/telephonecall.png'
import Modal from '../../../Component/CompanyAdmin/Location1/Modal.jsx';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import NetworkWifiIcon from '@mui/icons-material/NetworkWifi';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import SocialDistanceIcon from '@mui/icons-material/SocialDistance';
import { useWebSocket } from '../../../context/WebSocketContext.jsx' // i am edited websocket;
import { ClipLoader } from 'react-spinners';
import { Alert } from '@mui/material';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import ModalButton from '../FirstPageDesigns/ModalButton.jsx';
import RatingModal from './RatingModal.jsx';
import CraneFirstPage from './CraneFirstPage.jsx'


function StatusTracking({ vehicleNumber }) {

    const navigate = useNavigate()
    const { messages } = useWebSocket();
    const { state } = useLocation();
    const [currentStage, setCurrentStage] = useState([]); // Example stage
    console.log("currentStage123", currentStage)
    const [isImageContainerVisible, setIsImageContainerVisible] = useState(false);
    const [data, setData] = useState([]);
    const [dummyData, setDummyData] = useState([]);
    const [currentItems, setCurrentItems] = useState(data);
    const [vendorCurrentLatitude, setVendorCurrentLatitude] = useState("")
    const [vendorCurrentLongitude, setVendorCurrentLongitude] = useState("")
    const [selectedAction, setSelectedAction] = useState(null)
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertType, setAlertType] = useState(null);
    const [distance, setDistances] = useState([])
    console.log("distacneeerwerw", distance)
    const [avg, setAvg] = useState([])
    const [openFilterModal, setOpenFilterModal] = useState(false)
    const [filter, setFilter] = useState('')
    const [doneFetching, setDoneFetching] = useState(false)


    console.log("avg", avg)
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");
    const currentService = localStorage.getItem("currentService")

    const stages = [
        { label: "assigned", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/assignedTask.png' },
        { label: "moved", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/comingCrane.png' },
        { label: "reached", img: 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/checksuccess.png' },
    ];

    console.log('isImageContainer', isImageContainerVisible)

    useEffect(() => {
        if (messages.length > 0) {
            messages.forEach((message) => {
                console.log("messages123 status tracking", message)
                if (message.forPage === 'crane-user-all-cases') {
                    getData();
                }
            })
            messages.length = 0;
        }
        else {
            console.log('currentService12345', currentService)
            if (currentService != null) {
                getData();
            }
        }
        console.log("token", token, userId);
        if (token === "" || userId === "") {
            navigate("/");
        }
    }, [token, userId, navigate, messages, currentService]);


    const getFilteredData = (filter) => {
        console.log("data is here");

        const filteredData = [];

        const now = new Date();  // Current date and time
        const oneDay = 24 * 60 * 60 * 1000; // One day in milliseconds
        const yesterday = new Date(now.getTime() - oneDay); // Yesterday's date and time
        const weekBefore = new Date(now.getTime() - (oneDay * 7));
        const monthBefore = new Date(now.getTime() - (oneDay * 30));

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const todayDate = formatDate(now);
        const yesterdayDate = formatDate(yesterday);
        const weekBeforeDate = formatDate(weekBefore)
        const monthBeforeDate = formatDate(monthBefore)

        console.log("todayDate", todayDate)
        console.log("yesterdayDate", yesterdayDate)


        for (let i = 0; i < dummyData.length; i++) {

            console.log(dummyData[i]);
            console.log(currentService);
            // return
            let getTime = dummyData[i]?.[`${currentService}Details`]?.systemDate?.split('|');
            let assignedDate = getTime[0];
            let assignedTime = getTime[1];
            let assignedDateTime = new Date(`${assignedDate} ${assignedTime}`);

            if (filter === 'daily') {
                console.log("here i am daily")
                if (assignedDate === todayDate || assignedDate === yesterdayDate) {
                    const timeDifference = now - assignedDateTime;
                    if (timeDifference <= oneDay) {
                        console.log("Match found within last 24 hours:", data[i]);
                        filteredData.push(dummyData[i]);
                    }
                }
            }
            else if (filter === 'weekly') {
                console.log("here i am weekly")
                if (assignedDateTime >= weekBefore && assignedDateTime <= now) {
                    console.log("Match found within last 7 days:", data[i]);
                    filteredData.push(dummyData[i]);
                }
            }
            else if (filter === 'monthly') {
                if (assignedDateTime >= monthBefore && assignedDateTime <= now) {
                    console.log("Match found within last 30 days:", data[i]);
                    filteredData.push(dummyData[i]);
                }
            }
            else if (filter === 'year') {
                const yearBefore = new Date(now.getTime() - (oneDay * 365)); // Calculate date one year ago
                if (assignedDateTime >= yearBefore && assignedDateTime <= now) {
                    console.log("Match found within last year:", dummyData[i]);
                    filteredData.push(dummyData[i]);
                }
            }
        }
        if (filter === 'newest') {
            console.log("Sorting by newest to oldest");
            dummyData.sort((a, b) => {
                const dateA = new Date(a?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                return dateB - dateA; // Descending order
            });
            setData([...dummyData]);
        } else if (filter === 'oldest') {
            console.log("Sorting by oldest to newest");
            dummyData.sort((a, b) => {
                const dateA = new Date(a?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                const dateB = new Date(b?.[`${currentService}Details`]?.systemDate.split('|').join(' '));
                return dateA - dateB; // Ascending order
            });
            setData([...dummyData]);
        }
        else {
            setData(filteredData)
        }
    };

    const settingFilter = (filter) => {
        console.log('settingFilter calling: ');
        console.log("filter", filter)
        setFilter(filter)
        getFilteredData(filter)
        setOpenFilterModal(false)
    }

    const getData = async (e) => {
        console.log("userid", userId, currentService);
        console.log('currentService1234123', currentService.length, doneFetching)
        if (currentService !== '') {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getPersonalAccidentVehicleInfoById/${userId}/${currentService}/not-completed`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (response.data.message === "No accident vehicle data found.") {
                setData([])
                setDoneFetching(true)
            }
            else {
                console.log("response123421", response.data.data);
                console.log("data2", response.data.data2);

                let filteredData = response.data.data.filter((info) =>
                    info?.[`${currentService}Details`]?.customerAcceptedVendor && !info?.[`${currentService}Details`]?.confirmDoneWorking
                );

                let filteredImportant = filteredData.filter((info) =>
                    !info?.[`${currentService}Details`]?.vendorMoved
                )

                let filteredLessImportant = filteredData.filter((info) =>
                    info?.[`${currentService}Details`]?.vendorMoved
                )
                filteredData = [...filteredImportant, ...filteredLessImportant]
                setData(filteredData)

                setDummyData(filteredData)
                console.log("seTDATIOATN", filteredData);
                setDoneFetching(true)

                setCurrentItems(response.data.data);
            }
        }
    };

    const goToMap = (item) => {
        console.log("itemfromgotomap", item)
        console.log("item.accidentLatitude", `${item?.[`${currentService}Details`].accidentLatitude}`, "item.accidentLongitude", item.accidentLongitude, "vendorCurrentLatitude", vendorCurrentLatitude, "vendorCurrentLongitude", vendorCurrentLongitude)
        navigate('/map-vendor-distance', {
            state: {
                accidentLatitude: `${item?.[`${currentService}Details`].accidentLatitude}`,
                accidentLongitude: `${item?.[`${currentService}Details`].accidentLongitude}`,
                vendorLatitude: vendorCurrentLatitude,
                vendorLongitude: vendorCurrentLongitude,
                vehicleNo: `${item?.[`${currentService}Details`].vehicleNo}`,
                fromPage: "statusTracking"
            }
        })
    }

    const getStage = (vendorMoved, approvedReaching) => {
        return approvedReaching ? 2 : vendorMoved ? 1 : 0;
    }

    useEffect(() => {
        console.log('data changes', data.length, currentStage.length)
        console.log('curren4123', doneFetching)
        if (data.length > 0 && currentService && doneFetching === true) {
            console.log("push avg")

            const newAvg = Array(data.length).fill(0);

            const newCurrentStage = data.map((item) => {
                console.log("gostrage1")
                let gotStage = getStage(item?.[`${currentService}Details`]?.vendorMoved, item?.[`${currentService}Details`]?.approvedReaching)
                console.log("gostrage", gotStage)
                return gotStage;
            })
            setAvg(newAvg);
            setCurrentStage(newCurrentStage);
            console.log('currentService1231231231231', currentService)
            // data.forEach((item, index) => {
            //     console.log("push currentService", `${item?.[`${currentService}Details`][`${currentService}`]}`)
            //     // console.log("push currentService", `${item?.[`${currentService}Details`].accidentLongitude})

            //     console.log('hellow', `${item?.[`${currentService}Details`][`${currentService}`]}`, `${item?.[`${currentService}Details`].accidentLatitude}`, `${item?.[`${currentService}Details`].accidentLongitude}`, index)
            //     getVendorLocation(`${item?.[`${currentService}Details`][`${currentService}`]}`, `${item?.[`${currentService}Details`].accidentLatitude}`, `${item?.[`${currentService}Details`].accidentLongitude}`, index)
            //     getVendorRating(`${item?.[`${currentService}Details`][`${currentService}`]}`)
            // });
        }

    }, [data, currentService, doneFetching])


    function haversine(lat1, lon1, lat2, lon2) {
        console.log("accident latitude", lat1)
        console.log("accident longtitude", lon1)
        console.log("vehicle latitiude", lat2)
        console.log("vehicle longtitude", lon2)

        const toRad = (value) => (value * Math.PI) / 180;
        const R = 6371; // Earth radius in km

        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c;
        return distance;
    }

    const getVendorLocation = async (currentServiceId, accidentLatitude, accidentLongitude, index) => {
        try {
            console.log("disntaceadfafdaf", distance)
            console.log("craninging", currentServiceId, accidentLatitude, accidentLongitude, index)

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVendorCurrentLocation/${currentServiceId}`, { headers: { Authorization: `Bearer ${token}` } });
            if (response.data.status === true) {
                let vendorCurrentLatitude = response.data.data[0].latitude;
                let vendorCurrentLongitude = response.data.data[0].longitude;
                setVendorCurrentLatitude(vendorCurrentLatitude)
                setVendorCurrentLongitude(vendorCurrentLongitude)
                console.log("accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitud", accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude)
                const calculatedDistance = haversine(accidentLatitude, accidentLongitude, vendorCurrentLatitude, vendorCurrentLongitude).toFixed(2);

                distance.push(calculatedDistance)
            }
            else if (response.data.message === "User Not found take Location") {
                console.log("User Not found take Location")
            }
        } catch (error) {
            console.log("error in get Vendor Location", error.message)
        }
    }

    const getVendorRating = async (crane) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/customersRating/${crane}/${crane}`);
            console.log("coming Customer Rating", response.data)
            if (response.data.status === 404) {
                console.log("Not Found")
                avg.push(0)
            }
            else if (response.data.status === true) {
                let customerRating = response.data.data;
                console.log("coming Customer Rating", customerRating)
                if (customerRating.length !== 0) {
                    let average = customerRating.reduce((acc, item) => acc + parseInt(item.feedbackRatingCrane), 0);

                    avg.push(average / customerRating.length);
                }
            }
        } catch (error) {
            console.log("Error from get Vendor Rating", error.message)
        }
    }

    const vendorReached = async (item, action) => {
        console.log('items', item)
        console.log('items', `${item[`${currentService}Details`]?.AccidentVehicleCode}`)

        console.log('items2', `${process.env.REACT_APP_BACKEND_URL}/api/vendorReachedConfirmation/${userId}/${item[`${currentService}Details`]?.AccidentVehicleCode}/${action}/${userId}/${currentService}`)

        try {

            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/vendorReachedConfirmation/${userId}/${item[`${currentService}Details`]?.AccidentVehicleCode}/${action}/${userId}/${currentService}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.status) {
                console.log("updated successfully")

                setSelectedAction(action)
                // getData()
            }
            else console.log("there is some issue")

        }
        catch (error) {
            console.log("the error occured", error.message)
        }
    }


    const [currentItem, setCurrentltem] = useState({})
    const [formData, setFormData] = useState({
        feedbackRating: '',
        feedback: ""
    })

    const workDoneConfirmation = async (item, action) => {
        try {
            setCurrentltem(item)
            let response = await axios(`${process.env.REACT_APP_BACKEND_URL}/api/workDoneConfirmation/${userId}/${item[`${currentService}Details`]?.AccidentVehicleCode}/${action}/${currentService}`, {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            })
            if (response.data.status) {
                setAlertMessage("Updated successfully!");
                setAlertType("success"); // Bootstrap alert type for success
                // getData()
            } else {
                setAlertMessage("There is some issue.");
                setAlertType("danger"); // Bootstrap alert type for error
            }

        }
        catch (error) {
            setAlertMessage(`An error occurred: ${error.message}`);
            setAlertType("danger"); // Bootstrap alert type for error
        }
    }

    const submitNow = async (event, item) => {
        event.preventDefault();
        console.log("asdadfasdfasdf", `${process.env.REACT_APP_BACKEND_URL}/customersRating/${currentItem.accidentFileNo}/${userId}/${currentItem.crane}`)
        try {
            const response = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/customersRating/${currentItem.accidentFileNo}/${userId}/${currentItem?.[`${currentService}`]}`, JSON.stringify(formData), {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log("response", response);
            if (response.data.status === true) {
                setAlertMessage("Updated successfully!");
                setAlertType("success");
                // setTimeout(() => {
                //     onUpdate();
                // }, 2000);
            } else {
                const errorMessage = 'An error occurred';
                setAlertMessage("An error occurred");
                setAlertType("danger");
            }
        } catch (error) {
            console.error('Error response:', error.response);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            // setAlertInfo({ show: true, message: errorMessage.toString(), severity: 'error' });
        }
    };

    const [searchValue, setSearchValue] = useState('');
    useEffect(() => {
        if (vehicleNumber && dummyData.length) {
            setSearchValue(vehicleNumber)
            handleSearch(vehicleNumber)

        }
    }, [vehicleNumber, dummyData])

    // useEffect(() => {
    //     return () => setSearchValue("")
    // }, [])
    const handleSearch = (inputValue) => {
        const value = inputValue?.toLowerCase() ?? searchValue.toLowerCase();
        setSearchValue(value);
        const newRows = dummyData.filter((row) => {
            const formattedId = String(row.id).padStart(4, '0').toLowerCase(); // Make sure the formatted ID is lowercase
            const searchLower = value; // Use the updated search value directly

            const idValue = formattedId.includes(searchLower);
            const vehicleNoValue = (row?.[`${currentService}Details`]?.vehicleNo ?? '').toLowerCase().includes(searchLower);
            const chassisNoValue = (row?.[`${currentService}Details`]?.chassisNo ?? '').toLowerCase().includes(searchLower);

            return vehicleNoValue || chassisNoValue;
        });

        setData(newRows);
    };

    console.log("{item?.[`${currentService}Details`]?.customerAcceptedVendor", data[0]?.[`${currentService}Details`]?.customerAcceptedVendor)
    console.log("disptan", data.length, doneFetching, distance.length, avg.length)


    const [isCancelContainerVisible, setIsCancelContainerVisible] = useState(false);
    const [reasonsForDrop, setReasonsForDrop] = useState(false);
    const [selectedReasons, setSelectedReasons] = useState([]);
    const [otherReason, setOtherReason] = useState(null);
    const handleSelectReason = (reason) => {
        if (selectedReasons.includes(reason)) {
            // Remove from selected if already in array
            setSelectedReasons(selectedReasons.filter((item) => item !== reason));
        } else {
            // Add to selected array
            setSelectedReasons([...selectedReasons, reason]);
        }
    };
    const [errorMessage, setErrorMessage] = useState("");
    const reasons = [
        "Too much time taking",
        "Got Other Services",
        "Not Needed Now", "Changed my mind"
    ];
    const [isLoading, setIsLoading] = useState(false);
    const [alreadyCancelled, setAlreadyCancelled] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const [cancelled, setCancelled] = useState(false);
    const [showFull, setShowFull] = useState(false);
    const [showFull2, setShowFull2] = useState(false);

    const cancelingOrder = async (currentItem) => {
        try {
            console.log('insoidre', currentItem)
            const reasons = [...selectedReasons, otherReason].filter(Boolean);
            if (reasons.length === 0) {
                return setAlertInfo({ show: true, message: 'Select Respective Reason', severity: 'error' });
            }
            console.log('i am here')
            const response = await axios({
                method: "PUT",
                url: `${process.env.REACT_APP_BACKEND_URL}/api/cancellingOrderSecondaryStage/${currentItem?.[`${currentService}Details`].AccidentVehicleCode}/${currentService}/${userId}/${currentItem[`${currentService}Details`][`${currentService}`]}/${currentItem?.[`${currentService}Details`].vehicleNo}`,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                data: {
                    cancleOrderReason: [...selectedReasons, otherReason]
                }
            });

            if (response.data.status === true) {
                setIsCancelContainerVisible(false);
                setReasonsForDrop(false);
                setCancelled(true)
                // getData()
            } else {
                setAlreadyCancelled(true);
            }
        } catch (error) {
            console.error("Error canceling order:", error);
        }
    };

    const cancleCaseProcedureFunc = (item) => {
        setCurrentltem(item)
        setIsCancelContainerVisible(true)
        setReasonsForDrop(false)
        getVendorRating(item?.[`${currentService}Details`].crane)
        getVendorLocation(item?.[`${currentService}Details`].crane, item?.[`${currentService}Details`].accidentLatitude, item?.[`${currentService}Details`].accidentLongitude)
    }


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userRating, setUserRating] = useState(null);
    const [userItem, setUserItem] = useState(null);

    const handleRatingSubmit = (rating) => {

        setUserRating(rating);

        console.log("User selected rating:", rating);

        workDoneConfirmation(userItem.item, userItem.action)
    };

    const handleCancelRating = () => {
        console.log("User canceled the rating.");
        workDoneConfirmation(userItem.item, userItem.action)
    };

    const callRatingAndWorkDoneConfirmation = (item, action) => {

        // return
        setIsModalOpen(true)
        setUserItem({ item: item, action: action, })
    }
    
    return (
        <>
            {/* <div className='crane-section'>
                <h6 className="font-[700] text-center font-satoshi text-[61px] leading-[68px] text-[#FFFFFF] pt-[52px] mb-0 pb-[72px]">
                    Crane Service</h6>
                <div style={{ backdropFilter: "blur(20px)" }} className="flex bg-[#FFFFFF4D] max-w-[736px] w-full mx-auto py-[28px] rounded-[66px] pl-[40px] mb-[78px] pr-[28px] items-center justify-between">
                    <input type="text" className='outline-none bg-transparent text-[#FFFFFF] placeholder:text-[#FFFFFF] font-[500] text-[16px] leading-[20px]' placeholder='Search By Service' />
                    <img src={search} alt="" />
                </div>
            </div> */}
            {/* <CraneFirstPage/> */}
            <div className='flex md:flex-row flex-col justify-center gap-[30px] bg-white'>
                <CraneSideBar />
                <div className='max-w-[979px] py-[1rem] px-[1rem] w-full bg-[#EFF9FD] border-[1px] border-[#E7E4FC] rounded-[12px]'>
                    <h6 className="font-[700] font-satoshi text-[30px] text-[#0A0119] m-0 pb-[57px]">Status Tracking</h6>
                    {data.length > 0 && doneFetching === true && (
                        <div>
                            {data.map((item, dataIndex) => (
                                <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] relative ms:px-[40px] px-[20px] pb-[27px] rounded-[12px] mb-[3rem]">
                                    <div className="flex md:flex-row flex-col justify-between items-center pt-[19px] md:gap-0 gap-[20px]">
                                        <div className='flex items-center justify-between gap-[0.5rem]'>
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img3.png' className='h-[31px] w-[30px]' alt="" />
                                            <p className="m-0 font-[500] font-satoshi text-[16px] text-[#515151]">{`${currentService} is on the way`}</p>
                                            <button className='ml-[2rem]' onClick={() => (window.location.href = 'tel: +91 7800 78 4700')}><img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon6.svg' alt="phone" /></button>
                                        </div>
                                        <div className='flex w-full justify-end items-center md:gap-[80px] gap-[20px]'>
                                            <div className="flex flex-row gap-2 items-center">
                                                <button className='w-fit bg-[#000000] rounded-[12px] px-[9px] py-[4px] flex items-center font-satoshi text-[12px] font-[500] text-[#FFFFFF] gap-[6px]'>
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon18.svg' className='h-[20px] w-[20px]' alt="" />
                                                    {parseFloat(item?.[`${currentService}Details`]?.totalDistance || 0).toFixed(2)} Km
                                                </button>

                                                <div className="flex items-center ml-[4px]">
                                                    <NetworkWifiIcon className='h-[30px] w-[30px] text-green-500' />
                                                    <span className='font-satoshi text-[14px] animate-pulse ml-[5px] px-[4px] rounded-[10px] font-bold text-blue-600'>
                                                        {Boolean(!item?.[`${currentService}Details`]?.vendorMoved) && <span>Ready to move</span>}
                                                        {Boolean(item?.[`${currentService}Details`]?.vendorMoved && !item?.[`${currentService}Details`]?.vendorReached) && <span>On the way</span>}
                                                        {Boolean(item?.[`${currentService}Details`]?.vendorReached && !item?.[`${currentService}Details`]?.approvedReaching) && <span>Confirm</span>}
                                                        {Boolean(item?.[`${currentService}Details`]?.vendorReached && item?.[`${currentService}Details`]?.approvedReaching) && <span>Reached</span>}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="flex items-center justify-between max-w-[536px] mx-auto w-full md:pt-[30px] pt-[2rem]">
                                        {stages.map((stage, index) => (

                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    textAlign: "center",
                                                    position: "relative",
                                                    flex: 1,
                                                }}
                                            >

                                                <div
                                                    style={{
                                                        width: "2rem",
                                                        height: "2rem",
                                                        borderRadius: "50%",
                                                        // border:'1px solid black',
                                                        backgroundColor: currentStage[dataIndex] == index ? index == 2 ? "rgb(11 219 255)" : "#21A6E9" : "#ffffff",
                                                        boxShadow: currentStage[dataIndex] == index ? index == 2 ? "rgb(11 219 255)" : "#21A6E9" : "#ffffff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        border: currentStage[dataIndex] == index ? "2px solid #4CAF50" : "1px solid black",
                                                        transition: "background-color 0.3s ease",
                                                        zIndex: 1,
                                                        marginTop: "5px"
                                                    }}
                                                >

                                                    <img
                                                        src={stage.img}
                                                        alt={stage.label}
                                                        style={{
                                                            width: "1.5rem",
                                                            height: "1.5rem",
                                                            opacity: currentStage[dataIndex] <= index ? 1 : 0.5,
                                                        }}
                                                    />
                                                </div>

                                                <p
                                                    style={{
                                                        marginTop: "5px",
                                                        color: currentStage[dataIndex] <= index ? "black" : "#aaa",
                                                        fontWeight: currentStage[dataIndex] == index ? "bold" : "normal",
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    {stage.label}
                                                </p>

                                                {index < stages.length - 1 && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "10px", // Aligns with the center of the icon
                                                            left: "50%",
                                                            right: "-50%",
                                                            width: "100%",
                                                            height: "2px",
                                                            marginTop: '11px',
                                                            backgroundColor: index < currentStage[dataIndex] ? "#21A6E9" : "#B1B1B1",
                                                            zIndex: 0,
                                                        }}
                                                    ></div>
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    {/* <img src={img2}className='w-full pt-[17px]' alt="" /> */}
                                    <div className="h-full w-full rounded-xl overflow-hidden mt-3" onClick={() => { goToMap(item) }}>
                                        <MapForVendorDistance state={{ fromPage: 'statusTracking' }} />
                                    </div>
                                    <div className='pt-[26px]'>
                                        <div className="flex md:flex-row flex-col gap-[24px] items-start">
                                            {/* Image + Vehicle No container for small screens */}
                                            <div className="flex sm:flex-col flex-row items-center justify-around w-full md:hidden">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className="h-[100px] w-[100px]" alt="" />

                                                <div className='flex flex-col'>

                                                    <div>
                                                        <h6 className="m-0 font-[700] font-satoshi text-[18px] sm:text-[24px] text-[#0A0119] pb-[6px]">
                                                            {item?.[`${currentService}Details`].vehicleNo}
                                                        </h6>
                                                        <p className="font-[500] m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]">Vehicle No</p>
                                                    </div>
                                                    <div className='sm:hidden'>
                                                        <p className="font-[500] m-0 mt-3 font-satoshi font-semibold text-[14px] sm:text-[16px] text-[#515151]">Reg on {item?.[`${currentService}Details`]?.systemDate.split("T")[0]}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Image only for md+ screens */}
                                            <div className="hidden md:block">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className="h-[100px] w-[100px]" alt="" />
                                            </div>

                                            {/* Grid for all details (including Vehicle No for md+) */}
                                            <div className="grid sm:grid-cols-4 grid-cols-1 gap-[12px]">
                                                {/* Vehicle No shown only on md+ */}
                                                <div className="hidden md:block">
                                                    <h6 className="m-0 font-[700] font-satoshi text-[18px] sm:text-[24px] text-[#0A0119] pb-[6px]">
                                                        {item?.[`${currentService}Details`].vehicleNo}
                                                    </h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]">Vehicle No</p>
                                                </div>

                                                {/* Other fields (visible on all screens) */}
                                                <div>
                                                    <h6
                                                        className={`m-0 font-[700] font-satoshi text-[17px] sm:text-[24px] text-[#0A0119] pb-[6px] ${showFull
                                                            ? 'whitespace-normal overflow-visible text-clip'
                                                            : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px]'
                                                            }`}
                                                        onClick={() => setShowFull(!showFull)}
                                                    >
                                                        {item?.[`${currentService}Details`]?.pickupLocation}
                                                    </h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]">
                                                        Pickup Location
                                                    </p>
                                                </div>


                                                <div>
                                                    <h6
                                                        className={`font-[700] font-satoshi text-[17px] sm:text-[24px] mt-[20px]  text-[#0A0119] pb-[6px] md:mt-0  ${showFull2
                                                            ? 'whitespace-normal overflow-visible text-clip'
                                                            : 'whitespace-nowrap overflow-hidden text-ellipsis max-w-[180px]'
                                                            }`}
                                                        onClick={() => setShowFull2(!showFull2)}
                                                    >
                                                        {item?.[`${currentService}Details`]?.dropLocation}
                                                    </h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]">
                                                        Drop Location
                                                    </p>
                                                </div>
                                                <div className='hidden sm:block'>
                                                    <h6 className="font-[700] font-satoshi text-[17px] sm:text-[24px] mt-[20px] sm:mt-0 text-[#0A0119] pb-[6px]">
                                                        {item?.[`${currentService}Details`]?.systemDate.split("T")[0]}
                                                    </h6>
                                                    <p className="font-[500] m-0 font-satoshi text-[14px] sm:text-[16px] text-[#515151]">Date</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='flex justify-end'>
                                            <button className='bg-red-700  py-[3px] w-[50%] text-center mt-[15px] rounded-full text-[#FFFFFF] font-satoshi font-[400] text-[16px] sm:text-[24px]  py-[5px] leading-[33.6px]' onClick={() => cancleCaseProcedureFunc(item)}>Reject Case</button>
                                        </div>
                                        {Boolean(item?.[`${currentService}Details`]?.vendorReached && !item?.[`${currentService}Details`]?.approvedReaching) && (
                                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                                                <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md">
                                                    <p className="font-satoshi font-semibold text-[16px] mb-4 text-center">
                                                        Please confirm vendor driver has reached.
                                                    </p>
                                                    <div className="flex gap-4">
                                                        <button
                                                            className="bg-[#21A6E9] flex-1 py-2 rounded-full text-white font-satoshi font-medium text-[16px]"
                                                            onClick={() => vendorReached(item, true)}
                                                        >
                                                            Reached
                                                        </button>
                                                        <button
                                                            className="bg-red-700 flex-1 py-2 rounded-full text-white font-satoshi font-medium text-[16px]"
                                                            onClick={() => cancleCaseProcedureFunc(item)}
                                                        >
                                                            Not Reached
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {Boolean(item?.[`${currentService}Details`]?.detailsFilledAt != null && !item?.[`${currentService}Details`]?.approvedRightlyMeasured) && (
                                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                                                <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md">
                                                    <p className="font-satoshi font-semibold text-[16px] mb-4 text-center">
                                                        Please confirm the details provided.
                                                    </p>
                                                    <ModalButton
                                                        state={{
                                                            accidentVehicleCode: item?.[`${currentService}Details`]?.AccidentVehicleCode,
                                                            title: 'confirm details',
                                                            currentService: currentService,
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {Boolean(item?.[`${currentService}Details`]?.doneWorking) && (
                                            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                                                <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-md">
                                                    <p className="font-satoshi font-semibold text-[16px] mb-4 text-center">
                                                        Please confirm whether the work is done.
                                                    </p>
                                                    <div className="flex gap-3">
                                                        <button
                                                            className="bg-[#21A6E9] py-[10px] px-[12px] w-full rounded-full text-white font-satoshi font-medium text-[16px]"
                                                            onClick={() => workDoneConfirmation(item, true)}
                                                        >
                                                            Work Done
                                                        </button>
                                                        <button
                                                            className="bg-red-700 py-[10px] px-[12px] w-full rounded-full text-white font-satoshi font-medium text-[16px]"
                                                            onClick={() => workDoneConfirmation(item, false)}
                                                        >
                                                            Not Done Yet
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {alertMessage && (
                                            <div style={{ marginTop: "20px", fontSize: "12px", padding: "10px" }} className={`alert alert-${alertType} text-center`} role="alert">
                                                {alertMessage}
                                            </div>
                                        )}


                                        {isCancelContainerVisible && (
                                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] mt-[40px]">
                                                <div className="bg-white py-[42px] px-[50px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                                                    <h6 className="m-0 font-[700]  text-[30px] font-satoshi text-center text-[#000000]">Drop Case Procedure</h6>
                                                    <img onClick={(e) => {
                                                        setIsCancelContainerVisible(false)
                                                        setReasonsForDrop(false)
                                                        setSelectedReasons([])
                                                        setOtherReason('')
                                                    }}
                                                        src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon7.svg' className='absolute top-[12px] right-[12px] h-[35px] w-[35px]' alt="" />
                                                    <div>
                                                        {reasonsForDrop == false && (
                                                            <div>
                                                                <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px] my-4 text-[#0A0119] pb-[6px]">We are almost there to get you perfect crane service!!! </p>
                                                                <p className="m-0 font-[700] font-satoshi text-[17px] sm:text-[24px]  my-4 pb-[6px] text-[#EE3840]">Still want to opt-out for ❓ 🤔 </p>
                                                                <div className=" grid md:grid-cols-2 grid-cols-1 pt-[40px] items-center gap-[18px] ">
                                                                    <div
                                                                        // onClick={onClose}
                                                                        onClick={(e) => {
                                                                            setReasonsForDrop(false)
                                                                            setIsCancelContainerVisible(false)
                                                                            setSelectedReasons([])
                                                                            setOtherReason('')
                                                                        }}
                                                                        className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full justify-between items-center cursor-pointer">
                                                                        <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[36px] text-[#FFFFFF]">Don't Drop</button>
                                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                                    </div>
                                                                    <div onClick={() => setReasonsForDrop(true)} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                                        <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Drop Case</button>
                                                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                                    </div>
                                                                </div>
                                                            </div>)}

                                                        {reasonsForDrop == true && (
                                                            <div>
                                                                <div>
                                                                    <div>

                                                                        <div style={{ margin: "10px", marginTop: '20px', display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                                            {reasons.map((reason) => (
                                                                                <button
                                                                                    key={reason}
                                                                                    onClick={() => handleSelectReason(reason)}
                                                                                    style={{
                                                                                        fontSize: '16px',
                                                                                        display: "flex",
                                                                                        justifyContent: "center",
                                                                                        alignItems: "center",
                                                                                        padding: "15px",
                                                                                        borderRadius: "20px",
                                                                                        backgroundColor: selectedReasons.includes(reason) ? "#21A6E9" : "white",
                                                                                        color: selectedReasons.includes(reason) ? "white" : "black",

                                                                                        border: "1px solid #21A6E9",
                                                                                        cursor: "pointer",
                                                                                        boxShadow: selectedReasons.includes(reason) ? "0 4px 8px rgba(0,0,0,1.2)" : "0 3px 6px rgba(0, 0, 0, 0.5)"
                                                                                    }}
                                                                                >
                                                                                    {reason}
                                                                                </button>
                                                                            ))}
                                                                        </div>


                                                                        <label className="form-field" style={{ color: '#3f3c00', marginTop: '20px', fontSize: "14px" }}>
                                                                            <p style={{ textAlign: "left", fontSize: '16px' }}> Other Reason  : </p>
                                                                            <textarea
                                                                                style={{ margin: "10px 10px 5px 0px", width: "280px" }} className="form-control" name="otherReason" value={otherReason} onChange={(e) => setOtherReason(e.target.value)} />
                                                                        </label>

                                                                        {errorMessage && <div style={{ color: "red", margin: "10px 10px 20px 10px", marginBottom: "10px" }}>{errorMessage}</div>}


                                                                        <div className='pb-10'>
                                                                            {isLoading && (
                                                                                <div style={{ marginTop: '10px', display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                                                                    <ClipLoader color="black" loading={isLoading} />
                                                                                    <div style={{ marginTop: '10px', color: 'black' }}> Please Wait...</div>
                                                                                </div>
                                                                            )}
                                                                            {alreadyCancelled && (<div class="alert alert-danger" role="alert">
                                                                                You have already Cancelled Case !!!
                                                                            </div>)}
                                                                            {alertInfo.show && (
                                                                                <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                                                                    {alertInfo.message}
                                                                                </Alert>
                                                                            )}

                                                                            <div onClick={(e) => { cancelingOrder(currentItem) }} disabled={isLoading} className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                                                                                <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Confirm Drop Case</button>
                                                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[30px] w-[30px]' alt="" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                </div>
                                            </div>
                                        )}


                                    </div>
                                </div>))}
                        </div>
                    )}
                    {data.length === 0 && doneFetching && (
                        <NoDataFound />
                    )}
                </div>
            </div>
            {/* <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            /> */}
        </>
    )
}

export default StatusTracking;